import { createI18n } from 'vue-i18n'

import en from './locales/en.json'
import he from './locales/he.json'
import { getStorage } from '@/services/storage';

const savedLocale = getStorage('locale')
const browserLocale = navigator.language.startsWith('he') ? 'he' : 'en'

const locale = savedLocale || browserLocale;

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'en',
  messages: {
    en,
    he, //will be loaded via api
  },
})

export default i18n
